module.exports = __webpack_public_path__ + "odstraneni-tetovaze_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_1_after.jpg
// module id = 953
// module chunks = 0